export const experienceData = [
  {
    company: 'Bloomberg L.P.',
    department: 'Trading & Analytics',
    role: 'Software Engineer Intern',
    location: 'New York City, NY',
    duration: 'May 2021 - Aug 2021',
    duties: [
      'Built a Custom Formula Builder that supports saving, editing, and deleting custom columns, to be integrated into Bloomberg’s Multi-Asset Viewer (MAV), a real-time position and P&L monitor for portfolio management.',
      'Engineered the end-to-end implementation of the above project including creating the UI in React on the Bloomberg Terminal and writing a backend service in Python and SQL to communicate with the database.',
    ],
    skills: ['C++', 'PostgreSQL', 'Python', 'React', 'Typescript'],
    companyLogo: require('../../static/images/companies/bloomberg.png'),
    website:
      'https://www.bloomberg.com/company/careers/working-here/engineering/',
  },
  {
    company: 'Singapore Armed Forces',
    department: 'HQ Combat Service Support Command (G5 Branch)',
    role: 'Project Officer',
    location: 'Singapore, Singapore',
    duration: 'Aug 2020 - Dec 2020',
    duties: [
      'Developed and executed organizational strategies and policies to drive innovative change and business process engineering within the Army logistics command, such as advocating for an Army cloud management platform and artificial intelligence data analytics platform.',
      'Created partnerships with leading academic institutions and commercial enterprises to jointly incubate and accelerate technology trials.',
    ],
    skills: [],
    website: 'https://www.mindef.gov.sg/web/portal/mindef/home',
  },
  {
    company: 'Ministry of Home Affairs',
    department: 'Technology and Digital Services',
    role: 'Software Engineer Intern',
    location: 'Singapore, Singapore',
    duration: 'May 2020 - Jul 2020',
    duties: [
      'Researched and applied state-of-the-art natural language processing technologies, in the fields of sentiment analysis, named entity recognition, relation extraction, and more, via tools like Spacy, FlairNLP, and Tensorflow.',
      'Built a data visualization dashboard using React, Flask, and MongoDB, to streamline data analysis for over 1000 users to quickly digest critical information and make optimal operational decisions in real-time.',
      'Orchestrated the deployment, scaling, and management of Docker containers using Openshift Red Hat and Docker Compose, enabling 2000 words to be processed through 10 NLP models per minute.',
    ],
    skills: [
      'Docker',
      'Flask',
      'Keras',
      'MongoDB',
      'Openshift',
      'React',
      'Redux',
      'Tensorflow',
    ],
    website: 'https://www.mha.gov.sg/isd',
  },
  {
    company: 'Govtech',
    department: 'Government Digital Services (Distributed Ledger Team)',
    role: 'Software Engineer Intern',
    location: 'Singapore, Singapore',
    duration: 'May 2019 - Aug 2019',
    duties: [
      'Frontend development of an Ethereum based blockchain system (OpenCerts) which publishes and verifies educational certificates, that is used by over 15 institutes of higher learning.',
      'Collaborated with a small team of engineers to develop a digital identity verification mobile application, SGWorkPass, using the same blockchain system, React Native, and Expo, that has over 1,000,000 downloads in the app store.',
      'Upgraded code to ensure cross-browser compatibility and responsiveness in various browsers and mobile devices.',
      'Wrote unit tests and integration tests on various components to improve overall code coverage.',
    ],
    skills: ['AWS', 'Expo', 'React', 'Redux', 'Typescript'],
    companyLogo: require('../../static/images/companies/govtech.gif'),
    website: 'https://www.tech.gov.sg/',
  },
  {
    company: 'Singapore Armed Forces',
    department: 'Supply Base (West)',
    role: 'Human Resource Battalion & Deputy Operations Officer',
    location: 'Singapore, Singapore',
    duration: 'Jan 2017 - Jun 2018',
    duties: [
      'Spearheaded the development of a software-based attendance entry system over 6 different army bases, which led the Battalion HR office to attain the prestigious Human Resource Audit Proficiency Award.',
      'Supervised HR management and an integrated supply base of over 400 personnel, 100 vehicles and 25 military cookhouses, in a multi-component Logistics Battalion using Excel and HR software platforms to filter, identify, and analyze data.',
      'Oversaw consolidation effort for mechanized and motorized vehicles, which enabled active units and training institutes to focus on operational readiness and training outcomes, while ensuring administrative excellence in the Army supply system.',
    ],
    skills: ['CSS3', 'HTML5', 'Javascript', 'PostgreSQL', 'Python'],
    website: 'https://www.mindef.gov.sg/web/portal/mindef/home',
  },
];
